module.exports = __webpack_public_path__ + "img/totem-grey.b76fbc9c.svg";